// Sistema dinamico per caricare comuni italiani dal CSV
// Mappa i codici provincia numerici alle sigle

const PROVINCIA_CODE_TO_SIGLA = {
  '001': 'TO', '002': 'VC', '003': 'NO', '004': 'CN', '005': 'AT', '006': 'AL', '007': 'AO',
  '008': 'IM', '009': 'SV', '010': 'GE', '011': 'SP', '012': 'VA', '013': 'CO', '014': 'SO',
  '015': 'MI', '016': 'BG', '017': 'BS', '018': 'PV', '019': 'CR', '020': 'MN', '021': 'BZ',
  '022': 'TN', '023': 'VR', '024': 'VI', '025': 'BL', '026': 'TV', '027': 'VE', '028': 'PD',
  '029': 'RO', '030': 'UD', '031': 'GO', '032': 'TS', '033': 'PC', '034': 'PR', '035': 'RE',
  '036': 'MO', '037': 'BO', '038': 'FE', '039': 'RA', '040': 'FC', '041': 'PU', '042': 'AN',
  '043': 'MC', '044': 'AP', '045': 'MS', '046': 'LU', '047': 'PT', '048': 'FI', '049': 'LI',
  '050': 'PI', '051': 'AR', '052': 'SI', '053': 'GR', '054': 'PG', '055': 'TR', '056': 'VT',
  '057': 'RI', '058': 'RM', '059': 'LT', '060': 'FR', '061': 'CE', '062': 'BN', '063': 'NA',
  '064': 'AV', '065': 'SA', '066': 'AQ', '067': 'TE', '068': 'PE', '069': 'CH', '070': 'CB',
  '071': 'FG', '072': 'BA', '073': 'TA', '074': 'BR', '075': 'LE', '076': 'PZ', '077': 'MT',
  '078': 'CS', '079': 'CZ', '080': 'RC', '081': 'TP', '082': 'PA', '083': 'ME', '084': 'AG',
  '085': 'CL', '086': 'EN', '087': 'CT', '088': 'RG', '089': 'SR', '090': 'SS', '091': 'NU',
  '092': 'CA', '093': 'PN', '094': 'IS', '095': 'OR', '096': 'BI', '097': 'LC', '098': 'LO',
  '099': 'RN', '100': 'PO', '101': 'KR', '102': 'VV', '103': 'VB', '108': 'MB', '109': 'FM',
  '110': 'BT', '111': 'SU'
};

// Cache per i comuni caricati
let comuniCache = null;
let comuniPerProvinciaCache = {};

// Funzione per caricare i comuni dal CSV
const loadComuniFromCSV = async () => {
  if (comuniCache) {
    return comuniCache;
  }

  try {
    // Carica il file CSV
    const response = await fetch('/data/geographical/comuni_rows.csv');
    const csvText = await response.text();
    
    const lines = csvText.split('\n');
    const comuni = [];
    
    // Salta l'header (prima riga)
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      
      // Parse CSV - attenzione alle virgole nei nomi
      const values = [];
      let currentValue = '';
      let insideQuotes = false;
      
      for (let j = 0; j < line.length; j++) {
        const char = line[j];
        if (char === '"') {
          insideQuotes = !insideQuotes;
        } else if (char === ',' && !insideQuotes) {
          values.push(currentValue);
          currentValue = '';
        } else {
          currentValue += char;
        }
      }
      values.push(currentValue); // Aggiungi ultimo valore
      
      if (values.length >= 9) {
        const comuneData = {
          codice: values[0],
          nome: values[1].replace(/"/g, ''), // Rimuovi virgolette
          cap: values[4],
          provincia: values[8]
        };
        
        // Converti codice provincia in sigla
        const siglaProvincia = PROVINCIA_CODE_TO_SIGLA[comuneData.provincia];
        if (siglaProvincia) {
          comuni.push({
            nome: comuneData.nome,
            cap: comuneData.cap,
            siglaProvincia: siglaProvincia
          });
        }
      }
    }
    
    comuniCache = comuni;
    return comuni;
    
  } catch (error) {
    console.error('Errore nel caricamento dei comuni:', error);
    return [];
  }
};

// Funzione per ottenere i comuni di una provincia
export const getComuniByProvincia = async (siglaProvincia) => {
  if (!siglaProvincia) {
    return getDefaultComuni();
  }
  
  // Controlla cache
  if (comuniPerProvinciaCache[siglaProvincia]) {
    return comuniPerProvinciaCache[siglaProvincia];
  }
  
  try {
    const allComuni = await loadComuniFromCSV();
    const comuniProvincia = allComuni.filter(comune => 
      comune.siglaProvincia === siglaProvincia
    );
    
    // Ordina per nome
    comuniProvincia.sort((a, b) => a.nome.localeCompare(b.nome));
    
    // Cache il risultato
    comuniPerProvinciaCache[siglaProvincia] = comuniProvincia;
    
    return comuniProvincia;
  } catch (error) {
    console.error('Errore nel caricamento comuni per provincia:', error);
    return getDefaultComuni();
  }
};

// Funzione per cercare comuni per nome
export const searchComuni = async (query, siglaProvincia = null) => {
  if (!query || query.length < 2) {
    if (siglaProvincia) {
      return await getComuniByProvincia(siglaProvincia);
    }
    return [];
  }
  
  try {
    const allComuni = await loadComuniFromCSV();
    let comuniToSearch = allComuni;
    
    // Filtra per provincia se specificata
    if (siglaProvincia) {
      comuniToSearch = allComuni.filter(comune => 
        comune.siglaProvincia === siglaProvincia
      );
    }
    
    // Cerca per nome o CAP
    const risultati = comuniToSearch.filter(comune => 
      comune.nome.toLowerCase().includes(query.toLowerCase()) ||
      comune.cap.includes(query)
    );
    
    // Ordina per rilevanza (prima i match esatti, poi quelli che iniziano con la query)
    risultati.sort((a, b) => {
      const queryLower = query.toLowerCase();
      const aStartsWith = a.nome.toLowerCase().startsWith(queryLower);
      const bStartsWith = b.nome.toLowerCase().startsWith(queryLower);
      
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      return a.nome.localeCompare(b.nome);
    });
    
    return risultati.slice(0, 50); // Limita a 50 risultati per performance
    
  } catch (error) {
    console.error('Errore nella ricerca comuni:', error);
    return [];
  }
};

// Lista base di comuni per province senza dati specifici
export const getDefaultComuni = () => {
  return [
    { nome: 'Inserisci manualmente', cap: '' }
  ];
};

// Funzione per precaricare i comuni di una provincia (per performance)
export const preloadComuniByProvincia = async (siglaProvincia) => {
  if (!comuniPerProvinciaCache[siglaProvincia]) {
    await getComuniByProvincia(siglaProvincia);
  }
}; 